module.exports = __webpack_public_path__ + "c158904d3f474025d6f34ded39db91f9.svg";